import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useLang } from "../i18n";
import { Skull } from "lucide-react";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) { setError(apiError(err.response?.data?.detail) || err.message); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex items-center gap-2 mb-8"><Skull className="text-primary" size={28} /><span className="heading text-2xl font-bold text-white">MetalVault</span></div>
        <h2 className="heading text-3xl font-bold text-white mb-6">{t("reset_password")}</h2>
        {!token && <div className="mb-4 text-sm text-red-400">Token manquant / Missing token</div>}
        {error && <div className="mb-4 text-sm text-red-400">{error}</div>}
        {done ? (
          <p className="text-green-400">{t("password_changed")} ✓</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-caps text-xs text-zinc-400">{t("new_password")}</label>
              <input data-testid="reset-new-pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                className="mt-1 w-full bg-black border border-zinc-800 rounded-sm px-3 py-2.5 text-white focus:border-primary focus:outline-none" />
            </div>
            <button data-testid="reset-submit" type="submit" disabled={!token} className="w-full bg-primary text-primary-foreground label-caps py-3 rounded-sm font-semibold hover:bg-yellow-400 disabled:opacity-50">{t("reset_password")}</button>
          </form>
        )}
        <p className="mt-6 text-sm text-zinc-400"><Link to="/login" className="text-primary hover:underline">{t("back_to_login")}</Link></p>
      </div>
    </div>
  );
}
